module.exports = __webpack_public_path__ + "img/animation_500_kfza30pe.13f71a22.gif";